import axios from '@/request/http.js'




//首页三个图表
export const getWeatherCharts = (info) => {
    return axios.request({
        url: '/mobile/home/weather?lat=' + info.lat +'&lon=' + info.lon,
        method: 'get'
    })
}

//雷达图
export const getradarChart = (info) => {
    return axios.request({
        url: '/mobile/plant/radar?lat=' + info.lat + '&lon=' + info.lon,
        method: 'get'
    })
}

//首页-新闻
export const getNewsHot = () => {
    return axios.request({
        url: '/mobile/news/hot',
        method: 'get'
    })
}

//首页-溯源
export const getSourceHot = () => {
    return axios.request({
        url: 'mobile/source/hot',
        method: 'get'
    })
}

//新闻列表
export const getNewsList = (info) => {
    return axios.request({
        url: '/mobile/news/list?page=' + info.page + '&per_page=' + info.per_page,
        method: 'get'
    })
}

//根据id查新闻
export const getnewsShow = (info) => {
    return axios.request({
        url: '/mobile/news/show?id=' + info,
        method: 'get'
    })
}

//基地溯源列表
export const getBaseListArr = (info) => {
    return axios.request({
        url: '/mobile/source/list?page=' + info.page + '&per_page=' + info.per_page,
        method: 'get'
    })
}

//基地溯源页面
export const getBaseShow = (info) => {
    return axios.request({
        url: '/mobile/source/show?id=' + info + '&code=fjeo5ev9aeq6Ed94p68d8',
        method: 'get'
    })
}

//基地溯源页面-溯源农药肥料展示页面
export const getBaseAgricultural = (info) => {
    return axios.request({
        url: '/mobile/source/agricultural?id=' + info.id + '&type=' + info.type,
        method: 'get'
    })
}

//基地溯源页面-溯源图片展示
export const getBaseImg = (info) => {
    return axios.request({
        url: '/mobile/source/agricultural?id=' + info.id + '&type=' + info.type,
        method: 'get'
    })
}

//气象数据-统计
export const getWeatherCount = (info) => {
    return axios.request({
        url: '/mobile/weather/count?lat=' + info.lat + '&lon=' + info.lon,
        method: 'get'
    })
}


//气象数据-历史数据
export const getHistoryData = (info) => {
    return axios.request({
        url: '/mobile/weather/history?lat=' + info.lat + '&lon=' + info.lon + '&num='+ info.num,
        method: 'get'
    })
}


//气象数据-温度范围天数统计
export const getCountDay = (info) => {
    return axios.request({
        url: '/mobile/weather/count/day?lat=' + info.lat + '&lon=' + info.lon + '&year=' + info.year + '&star_tem=' + info.start_tem + '&end_tem=' + info.end_tem,
        method: 'get'
    })
}

//气象数据-每月详细统计
export const getCountMonth = (info) => {
    return axios.request({
        url: '/mobile/weather/count/month?lat=' + info.lat + '&lon=' + info.lon + '&time=' + info.time,
        method: 'get'
    })
}



//农场

//获取基地列表
export const getBaseList = () => {
    return axios.request({
        url: '/map/node',        
        method: 'GET'
    })
}

//获取地块
export const getNodePointHome = (info) => {
    return axios.request({
        url: '/map/land?uuid=' + info.uuid,        
        method: 'GET'
    })
}

//获取阀门列表,阀门位置
export const getNodeValvePoint = (info) => {
    return axios.request({
        url: '/map/valve?uuid=' + info.uuid,        
        method: 'GET'
    })
}

//获取摄像头位置
export const getNodeCamera = (info) => {
    return axios.request({
        url: '/map/camera?uuid=' + info.uuid,        
        method: 'GET'
    })
}








//获取摄像头列表
export const getCameraList = (info) => {
    return axios.request({
        url: '/camera/list?node_uuid=' + info.uuid,        
        method: 'GET'
    })
}

//获取摄像头照片
export const getCameraImages = (info) => {
    return axios.request({
        url: '/camera/check?page=' + info.page + '&per_page=' + info.per_page + '&uuid=' + info.uuid + '&start_time=' + info.start_time + '&end_time=' + info.end_time,        
        method: 'GET'
    })
}


//获取基地气象站
export const getNodeWeatherStation = (info) => {
    return axios.request({
        url: '/map/weather/current?uuid=' + info.uuid,        
        method: 'GET'
    })
}

//获取基地气象数据
export const getStationWeatherInfo = (info) => {
    return axios.request({
        url: '/weather/list?uuid=' + info.uuid + '&type=' + info.type,        
        method: 'GET'
    })
}

//获取气象站表格数据
export const getWeatherData = (info) => {    
    return axios.request({
        url: '/weather/data',
        data: info.data,        
        method: 'POST'
    })
}

//获取气象站图表数据
export const getWeatherChart = (info) => {
    return axios.request({
        url:'/weather/list?uuid=' + info.uuid + '&type=' + info.type,
        data: info.data,        
        method: 'POST'
    })
}

/* 用户获取所属所有气象站 */
export const getWeatherName = (info) => {
    return axios.request({
        url: '/weather/relation/user?weather_type=' + info.weather_type,
        method: 'get'
    })
}

/* 获得气象数据统计数据 */
export const weatherCount = (info) => {
    return axios.request({
        url: '/count/weather',
        data: info,
        method: 'post'
    })
}

/* 获得土壤数据统计数据 */
export const getSoilCount = (info) => {
    return axios.request({
        url: '/count/soil',
        data: info,
        method: 'post'
    })
}

/* 获得气象数据统计数据-经纬度 */
export const getWeatherCountHistory = (info) => {
    return axios.request({
        url: '/count/history',
        data: info,
        method: 'post'
    })
}

//获取轮灌组
export const getRotationList = (info) => {
    return axios.request({
        url: '/irrigate/list?uuid=' + info.uuid,       
        method: 'GET'
    })
}

//新增网关轮灌组
export const addWebRotation = (info) => {
    return axios.request({
        url: '/irrigate/gateway',
        data:info,    
        method: 'post'
    })
}











//农艺
//农艺-作物列表
export const getCropList = () => {
    return axios.request({
        url: '/mobile/agriculture/crop',
        method: 'get'
    })
}

//农艺-施肥/植保/园艺物候期全年方案
export const getSchemeYear = (info) => {
    return axios.request({
        url: '/mobile/agriculture/scheme?area_code=' + info.area_code + '&crop_id=' + info.crop_id + '&param_id=' + info.param_id + '&type=' + info.type + '&node_uuid=' + info.node_uuid,
        method: 'get'
    })
}

//农艺-施肥/植保/园艺物候期详细方案
export const getSchemeDetailed = (info) => {
    return axios.request({
        url: '/mobile/agriculture/scheme/detail?scheme_id=' + info.scheme_id + '&grow_id=' + info.grow_id,
        method: 'get'
    })
}

//农艺-加入收藏
export const schemeCollect = (info) => {
    return axios.request({
        url: '/mobile/agriculture/collect?scheme_id='+info,
        method: 'get'
    })
}

//农艺-收藏列表
export const getCollectList = () => {
    return axios.request({
        url: '/mobile/agriculture/collect/list',
        method: 'get'
    })
}

//修改密码
export const getUpPassword = (info) => {
    return axios.request({
        url:'/mobile/user/edit/pwd',
        data: info,        
        method: 'POST'
    })
}